/**
 * The category of the ticket redemption code type
 */
export var TicketRedemptionCodeCategory;
(function (TicketRedemptionCodeCategory) {
    TicketRedemptionCodeCategory["Voucher"] = "Voucher";
    TicketRedemptionCodeCategory["ThirdPartyMemberCard"] = "ThirdPartyMemberCard";
    TicketRedemptionCodeCategory["MemberSubscriptionCard"] = "MemberSubscriptionCard";
})(TicketRedemptionCodeCategory || (TicketRedemptionCodeCategory = {}));
//# sourceMappingURL=ticket-redemption-code-category.js.map